import type {IABTestConfiguration} from "@pg-mono/ab-testing";
import {rpAppPath} from "@pg-mono/rp-routes";

import {OngoingABTests} from "./ongoing_ab_tests_enum";

export const USP_LISTING_TILE_AB_TEST_ID = "rp-tile-usp";
export const USP_LISTING_TILE_CONTROL_VARIANT = "rp_tile_usp_2026_07_control" as const;
export const USP_LISTING_TILE_TREATMENT_VARIANT = "rp_tile_usp_2026_07_treatment" as const;

/**
 * A/B test managed by Amplitude Experiment. The Amplitude flag must expose
 * `rp_tile_usp_2026_07_control` and `rp_tile_usp_2026_07_treatment` variants. The cookie keeps the assignment stable
 * when Amplitude is temporarily unavailable and remains part of the SSR cache key.
 * Override in dev: ?ab_test_experiment=rp-tile-usp&ab_test_variant=rp_tile_usp_2026_07_treatment|rp_tile_usp_2026_07_control
 */
export const uspListingTileAbTest: IABTestConfiguration = {
    id: USP_LISTING_TILE_AB_TEST_ID,
    name: OngoingABTests.USP_LISTING_TILE,
    expires: new Date(2027, 0, 1),
    path: rpAppPath.base,
    variants: [USP_LISTING_TILE_CONTROL_VARIANT, USP_LISTING_TILE_TREATMENT_VARIANT],
    withSSR: true,
    matchOnAllPaths: true,
    useAmplitude: true
};
import type {IABTestConfiguration} from "@pg-mono/ab-testing";
import {rpAppPath} from "@pg-mono/rp-routes";

import {OngoingABTests} from "./ongoing_ab_tests_enum";

export const USP_LISTING_TILE_AB_TEST_ID = "rp-tile-usp";
export const USP_LISTING_TILE_CONTROL_VARIANT = "rp_tile_usp_2026_07_control" as const;
export const USP_LISTING_TILE_TREATMENT_VARIANT = "rp_tile_usp_2026_07_treatment" as const;

/**
 * A/B test managed by Amplitude Experiment. The Amplitude flag must expose
 * `rp_tile_usp_2026_07_control` and `rp_tile_usp_2026_07_treatment` variants. The cookie keeps the assignment stable
 * when Amplitude is temporarily unavailable and remains part of the SSR cache key.
 * Override in dev: ?ab_test_experiment=rp-tile-usp&ab_test_variant=rp_tile_usp_2026_07_treatment|rp_tile_usp_2026_07_control
 */
export const uspListingTileAbTest: IABTestConfiguration = {
    id: USP_LISTING_TILE_AB_TEST_ID,
    name: OngoingABTests.USP_LISTING_TILE,
    expires: new Date(2027, 0, 1),
    path: rpAppPath.base,
    variants: [USP_LISTING_TILE_CONTROL_VARIANT, USP_LISTING_TILE_TREATMENT_VARIANT],
    withSSR: true,
    matchOnAllPaths: true,
    useAmplitude: true
};
